import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from '@odin-labs/components';
import { ChevronRightIcon, ExclamationCircleIcon } from 'components/icons';
import { cn } from 'utils';
import { STAT_PLACEHOLDER } from 'containers/jobsite/tabs/jobsiteOverview/helpers';
import { Shimmer } from 'containers/jobsite/tabs/jobsiteOverview/components/JobsiteOverviewStates';

export type JobsiteOverviewOnboardingCardProps = {
  onboardingStats: Record<string, string | number | null | undefined>;
  linkQueryString: string;
  loading?: boolean;
};

const swallowLinkClick = (e: React.MouseEvent): void => {
  e.preventDefault();
  e.stopPropagation();
};

export function JobsiteOverviewOnboardingCard({
  onboardingStats,
  linkQueryString,
  loading = false,
}: JobsiteOverviewOnboardingCardProps): ReactElement {
  return (
    <Link
      to={`/onboardings?${linkQueryString}`}
      className={cn(
        'odin-flex odin-flex-col odin-gap-4',
        'odin-rounded-2xl odin-border odin-border-odin-medium-gray',
        'odin-bg-odin-white odin-p-6',
        'odin-transition-all odin-duration-200 hover:odin-border-odin-dark-gray',
      )}
    >
      <div className="odin-flex odin-items-center odin-justify-between odin-gap-2">
        <div className="odin-flex odin-items-center odin-gap-2">
          <span className="odin-text-sm odin-text-odin-navy">Onboarding</span>
          <Tooltip
            placement="right"
            trigger={
              <span onClick={swallowLinkClick} className="odin-inline-flex">
                <ExclamationCircleIcon className="odin-w-3.5 odin-h-3.5 odin-text-odin-navy odin-mt-1" />
              </span>
            }
          >
            These stats are time-insensitive and don&apos;t vary with the date
            picker.
          </Tooltip>
        </div>
        <ChevronRightIcon className="odin-w-3 odin-h-3 odin-shrink-0 odin-text-odin-navy" />
      </div>
      <div className="odin-flex odin-items-center odin-gap-6 odin-mt-3">
        {Object.entries(onboardingStats).map(([label, value]) => (
          <div
            key={label}
            className="odin-flex odin-flex-row odin-grow odin-justify-start"
          >
            <div className="odin-flex odin-flex-col odin-gap-0.5 odin-items-start">
              {loading ? (
                <Shimmer className="odin-h-6 odin-w-10 odin-my-0.5" />
              ) : (
                <span className="odin-text-lg odin-font-semibold odin-text-odin-navy">
                  {value ?? STAT_PLACEHOLDER}
                </span>
              )}
              <span className="odin-text-sm odin-text-odin-navy">{label}</span>
            </div>
          </div>
        ))}
      </div>
    </Link>
  );
}
